import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

function applyCellTypes(ws, aoa) {
  for (let r = 0; r < aoa.length; r++) {
    for (let c = 0; c < aoa[r].length; c++) {
      const value = aoa[r][c]
      const cellRef = XLSX.utils.encode_cell({ r, c })
      const cell = ws[cellRef]
      if (!cell) continue

      const str = value == null ? '' : String(value)
      if (/^\d+\.\d+$/.test(str)) {
        cell.t = 'n'
        cell.v = parseFloat(str)
      } else if (str && str.startsWith('0') && str.length > 1) {
        cell.t = 's'
        cell.v = str
      } else if (/^-?\d+$/.test(str)) {
        cell.t = 'n'
        cell.v = parseInt(str, 10)
      } else {
        cell.t = 's'
        cell.v = str
      }
    }
  }
}

export async function exportWithSheetJS(sheetData, fileName) {
  const aoa = [sheetData.headers, ...sheetData.rows]
  const ws = XLSX.utils.aoa_to_sheet(aoa)
  applyCellTypes(ws, aoa)

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const normalizedName = fileName.endsWith('.xlsx') ? fileName : fileName + '.xlsx'
  saveAs(blob, normalizedName)

  await new Promise(resolve => setTimeout(resolve, 0))
}
